export default __webpack_public_path__ + "static/media/fruit28.54c1987e.jpg";